// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-button[data-v-445c683f] {\n  color: #4D7A98;\n  font-weight: bold;\n  background-color: transparent;\n  border-radius: 5px;\n  border: 2px solid #4D7A98;\n}\n.custom-button[data-v-445c683f]:hover {\n  color: #FFFFFF;\n  background-color: #4D7A98;\n}\n", ""]);
// Exports
module.exports = exports;
